export const CDN_ROOT = process.env.NEXT_PUBLIC_CDN_ROOT;
export const ISR_REVALIDATE_TIMEOUT = Number(process.env.ISR_REVALIDATE_TIMEOUT || 300);
export const NEXT_PUBLIC_SIMULATE_DOMAIN = process.env.NEXT_PUBLIC_SIMULATE_DOMAIN;
export const CMS = {
    NEXT_API_PATH: '/api/cms',
    API_URL: process.env.CMS_API_URL + '/graphql',
    REST_API_ROOT: process.env.CMS_API_URL + '/api',
};
export const AUTH = {
    NEXT_API_PATH: '/api/auth',
    API_URL: process.env.AUTH_API_URL + '/graphql',
};

export const featureFlagConfig = {
    appName: 'dorik',
    url: process.env.NEXT_PUBLIC_FF_URL,
    clientKey: process.env.NEXT_PUBLIC_FF_CLIENT_KEY || 'client_proxy',
    refreshInterval: process.env.NEXT_PUBLIC_FF_REFRESH || 300,
};
